<template>
  <div>
    <hgroup class="has-text-centered has-margin-bottom-200">
      <p class="title is-2">
        {{ $store.state.brand.name }}
      </p>
      <p class="subtitle is-4">
        {{ $t("_sentence.sign_in_to_your_account") }}
      </p>
    </hgroup>
    <template v-if="isSupportedOauthClient">
      <b-message v-if="hasRegistrationEnabled" type="is-dark">
        <i18n path="_sentence.dont_yet_have_an_account">
          <template #action>
            <router-link :to="clientRegisterRoute">
              <u>{{ $t("_action.create_one_here") }}</u>
            </router-link>
          </template>
        </i18n>
      </b-message>
      <client-login-form />
    </template>
    <template v-else>
      <b-message type="is-dark">
        <i18n path="_sentence.action_unsupported_by_oauth_client">
          <template #action>{{ $t("_.customer_login") }}</template>
          <template #origin>
            <strong>{{ currentOauthClient }}</strong>
          </template>
          <template #click>
            <a :href="defaultOauthClientRedirect">{{
              $t("_action.click_here").toString().toLowerCase()
            }}</a>
          </template>
        </i18n>
      </b-message>
    </template>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { ClientRoutes } from "@/data/enums/router";
import { mapGetters } from "vuex";

export default defineComponent({
  name: "Login",
  components: {
    "client-login-form": () =>
      import("@/components/app/client/clientLoginForm.vue")
  },
  data: () => ({
    clientRegisterRoute: { name: ClientRoutes.REGISTER }
  }),
  computed: {
    ...mapGetters({
      currentOauthClient: "auth/client/currentOauthClient",
      defaultOauthClient: "auth/client/defaultOauthClient",
      defaultOauthClientRedirect: "auth/client/defaultOauthClientRedirect",
      hasRegistrationEnabled: "brand/hasRegistrationEnabled",
      isSupportedOauthClient: "auth/client/isSupportedOauthClient"
    })
  }
});
</script>
